import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';
import {
  convertFromTitleSearchRequestResponseArrayToTitleSearchRequestDataArray,
  convertFromTitleSearchRequestResponseToTitleSearchRequestData,
  ITitleSearchRequestData,
  ITitleSearchRequestResponse,
} from '../../../types/order/title/ITitleSearchRequest';
import {
  convertFromRedVisionSearchResponseToRedVisionSearchData,
  IRedVisionSearchData,
  IRedVisionSearchResponse,
} from '../../../types/order/title/IRedVisionSearch';
import { baseUrlService } from '../../../ui-toolkit/rest/BaseUrlService';

export const getTitleSearchHistoryAsync = async (orderId: string): Promise<ITitleSearchRequestData[]> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<ITitleSearchRequestResponse[]>(`/lender/v2/admin/vendor/orders/${orderId}/title_search_requests`)
    .then((response) => convertFromTitleSearchRequestResponseArrayToTitleSearchRequestDataArray(response.data))
    .catch(axiosErrorHandler);

export const createTitleSearchAsync = async (orderId: string): Promise<ITitleSearchRequestData> =>
  APIFactory(baseUrlService.ApiLocation)
    .post<ITitleSearchRequestResponse>(`/lender/v2/admin/vendor/orders/${orderId}/title_search_requests`)
    .then((response) => convertFromTitleSearchRequestResponseToTitleSearchRequestData(response.data))
    .catch(axiosErrorHandler);

export const cancelTitleSearchAsync = async (titleSearchId: string): Promise<ITitleSearchRequestData> =>
  APIFactory(baseUrlService.ApiLocation)
    .patch<ITitleSearchRequestResponse>(`/lender/v2/admin/vendor/title_search_requests/${titleSearchId}/cancel`)
    .then((response) => convertFromTitleSearchRequestResponseToTitleSearchRequestData(response.data))
    .catch(axiosErrorHandler);

export const getRedVisionSearchAsync = async (orderId: string): Promise<IRedVisionSearchData> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<IRedVisionSearchResponse>(`/timber/api/internal/public_orders/get_title_search/${orderId}`)
    .then((response) => convertFromRedVisionSearchResponseToRedVisionSearchData(response.data))
    .catch(axiosErrorHandler);
